import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function MagicWand({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <MagicWand.Outline {...props} />
  ) : (
    <MagicWand.Solid {...props} />
  );
}

MagicWand.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M14.4258 12.7775L12.2775 10.6292C11.9847 10.3364 11.8383 10.19 11.6803 10.1117C11.3798 9.96277 11.027 9.96277 10.7264 10.1117C10.5685 10.19 10.4221 10.3364 10.1292 10.6292C9.83638 10.9221 9.68996 11.0685 9.61169 11.2264C9.46277 11.527 9.46277 11.8798 9.61169 12.1803C9.68996 12.3383 9.83638 12.4847 10.1292 12.7775L12.2775 14.9258M14.4258 12.7775L20.8708 19.2225C21.1636 19.5153 21.31 19.6617 21.3883 19.8197C21.5372 20.1202 21.5372 20.473 21.3883 20.7736C21.31 20.9315 21.1636 21.0779 20.8708 21.3708C20.5779 21.6636 20.4315 21.81 20.2736 21.8883C19.973 22.0372 19.6202 22.0372 19.3197 21.8883C19.1617 21.81 19.0153 21.6636 18.7225 21.3708L12.2775 14.9258M14.4258 12.7775L12.2775 14.9258"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M17.5 2L17.7948 2.7966C18.1813 3.84117 18.3746 4.36345 18.7556 4.74445C19.1366 5.12545 19.6588 5.31871 20.7034 5.70523L21.5 6L20.7034 6.29477C19.6588 6.68129 19.1366 6.87456 18.7556 7.25555C18.3746 7.63655 18.1813 8.15883 17.7948 9.2034L17.5 10L17.2052 9.2034C16.8187 8.15884 16.6254 7.63655 16.2444 7.25555C15.8634 6.87455 15.3412 6.68129 14.2966 6.29477L13.5 6L14.2966 5.70523C15.3412 5.31871 15.8634 5.12545 16.2444 4.74445C16.6254 4.36345 16.8187 3.84117 17.2052 2.7966L17.5 2Z"
          strokeWidth="1.5"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M6.5 4L6.72108 4.59745C7.01097 5.38087 7.15592 5.77259 7.44167 6.05834C7.72741 6.34408 8.11913 6.48903 8.90255 6.77892L9.5 7L8.90255 7.22108C8.11913 7.51097 7.72741 7.65592 7.44166 7.94167C7.15592 8.22741 7.01097 8.61913 6.72108 9.40255L6.5 10L6.27892 9.40255C5.98903 8.61913 5.84408 8.22741 5.55833 7.94167C5.27259 7.65592 4.88087 7.51097 4.09745 7.22108L3.5 7L4.09745 6.77892C4.88087 6.48903 5.27259 6.34408 5.55833 6.05833C5.84408 5.77259 5.98903 5.38087 6.27892 4.59745L6.5 4Z"
          strokeWidth="1.5"
          strokeLinejoin="round"
          stroke="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

MagicWand.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
